/* global getStorageItem:false */
/* global globalMethods:false */

(function() {
	globalMethods.detectCountry = function() {
		var country = getStorageItem('country');

		if (country) {
			document.body.setAttribute('data-country', country);
		}
	};

	globalMethods.detectCountry();
})();
